var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewScheduled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 99,
    viewBox: "0 0 105 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4383_15218)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 14,
    width: 49.5361,
    height: 49.5361,
    rx: 7.86288,
    fill: "#FF6900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6144 28.0215V32.4771M40.7031 28.0215V32.4771",
    stroke: "white",
    strokeWidth: 1.67086,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2719 30.248H44.0441C39.8433 30.248 37.7429 30.248 36.4378 31.5531C35.1328 32.8581 35.1328 34.9585 35.1328 39.1593V41.3871C35.1328 45.5879 35.1328 47.6884 36.4378 48.9933C37.7429 50.2984 39.8433 50.2984 44.0441 50.2984H46.2719C50.4727 50.2984 52.5732 50.2984 53.8781 48.9933C55.1832 47.6884 55.1832 45.5879 55.1832 41.3871V39.1593C55.1832 34.9585 55.1832 32.8581 53.8781 31.5531C52.5732 30.248 50.4727 30.248 46.2719 30.248Z",
    stroke: "white",
    strokeWidth: 1.67086,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1328 36.9316H55.1832",
    stroke: "white",
    strokeWidth: 1.67086,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1537 41.3867H45.1638M45.1537 45.8423H45.1638M49.6044 41.3867H49.6144M40.7031 41.3867H40.7131M40.7031 45.8423H40.7131",
    stroke: "white",
    strokeWidth: 2.22782,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4383_15218",
    x: -14.5967,
    y: -20.5967,
    width: 118.728,
    height: 118.728,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.2983
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4383_15218"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4383_15218",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewScheduled);
export default __webpack_public_path__ + "static/media/InterviewScheduled.4171ac29ec9a8d87de90014edf96e903.svg";
export { ForwardRef as ReactComponent };